import React from "react";
import "./Personal.css";

function Personal() {
  return <div className="personal">Personal Component</div>;
}

export default Personal;
